/**
 * @file new-state.icon.tsx
 * @description Компонент для отображения иконки статуса новой задачи.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

interface INewTaskStateIconProps extends IIconProps {
    badgeColor?: string;
}

export const NewTaskStateIcon = ({
    className,
    size = '1.7995vmin',
    color = '#4B6178',
    badgeColor = '#25B700',
    onClick,
    ...props
}: INewTaskStateIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }} {...props}>
            <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1C8.42758 1 8.77419 1.34662 8.77419 1.77419V4.87097C8.77419 5.29854 8.42758 5.64516 8 5.64516C7.57242 5.64516 7.22581 5.29854 7.22581 4.87097V1.77419C7.22581 1.34662 7.57242 1 8 1ZM2.34297 3.3429C2.64532 3.04056 3.13551 3.04056 3.43785 3.3429L5.6276 5.53265C5.92994 5.83499 5.92994 6.32518 5.6276 6.62752C5.32526 6.92986 4.83507 6.92986 4.53272 6.62752L2.34297 4.43777C2.04063 4.13543 2.04063 3.64524 2.34297 3.3429ZM13.6572 3.3429C13.9595 3.64524 13.9595 4.13543 13.6572 4.43777L11.4674 6.62752C11.1651 6.92986 10.6749 6.92986 10.3725 6.62752C10.0702 6.32518 10.0702 5.83499 10.3725 5.53265L12.5623 3.3429C12.8646 3.04056 13.3548 3.04056 13.6572 3.3429ZM0 9C0 8.57242 0.346618 8.22581 0.774194 8.22581H3.87097C4.29854 8.22581 4.64516 8.57242 4.64516 9C4.64516 9.42758 4.29854 9.77419 3.87097 9.77419H0.774194C0.346618 9.77419 0 9.42758 0 9ZM11.3548 9C11.3548 8.57242 11.7015 8.22581 12.129 8.22581H15.2258C15.6534 8.22581 16 8.57242 16 9C16 9.42758 15.6534 9.77419 15.2258 9.77419H12.129C11.7015 9.77419 11.3548 9.42758 11.3548 9ZM5.6276 11.3725C5.92994 11.6748 5.92994 12.165 5.6276 12.4674L3.43785 14.6571C3.13551 14.9594 2.64532 14.9594 2.34297 14.6571C2.04063 14.3548 2.04063 13.8646 2.34297 13.5622L4.53272 11.3725C4.83507 11.0701 5.32526 11.0701 5.6276 11.3725ZM10.3725 11.3725C10.6749 11.0701 11.1651 11.0701 11.4674 11.3725L13.6572 13.5622C13.9595 13.8646 13.9595 14.3548 13.6572 14.6571C13.3548 14.9594 12.8646 14.9594 12.5623 14.6571L10.3725 12.4674C10.0702 12.165 10.0702 11.6748 10.3725 11.3725ZM8 12.3548C8.42758 12.3548 8.77419 12.7015 8.77419 13.129V16.2258C8.77419 16.6534 8.42758 17 8 17C7.57242 17 7.22581 16.6534 7.22581 16.2258V13.129C7.22581 12.7015 7.57242 12.3548 8 12.3548Z"
                    fill="currentcolor"
                />
                <circle cx="13.3337" cy="3.66667" r="3.11111" fill={badgeColor} stroke="white" strokeWidth="0.888889" />
            </svg>
        </div>
    );
};
